export default __webpack_public_path__ + "static/media/Blog-Default-Img.02f0d62a.png";